export default __webpack_public_path__ + "static/media/Eternal_Empire_LE.a9c81256.jpg";